// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_nKJ","cls2":"ReportList-cls2_gNp ReportList-cls1_nKJ"};